import { render, staticRenderFns } from "./StorePackDetail.vue?vue&type=template&id=3c8b0600&scoped=true&"
import script from "./StorePackDetail.vue?vue&type=script&lang=js&"
export * from "./StorePackDetail.vue?vue&type=script&lang=js&"
import style0 from "./StorePackDetail.vue?vue&type=style&index=0&id=3c8b0600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b0600",
  null
  
)

export default component.exports